import React, { useState, FocusEvent } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import UserIcon from '../../assets/User.svg';
import './CardHolderNameInput.css';

interface CardHolderNameInputProps {
  type: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: String;
  placeholder?: string;
}

const CustomInputField = styled(TextField)(({ theme }) => ({
  height: '70px',
  backgroundColor: '#333', // Dark background
  color: '#C0C0C0', // white text
  paddingLeft: '12px',
  fontFamily: 'Open Sans',
  marginBottom: '13px',
  borderColor: '#365F91',
  border: '1.2px solid transparent',
  boxSizing: 'border-box',
  background: `
    linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
  `,
  borderImageSlice: 1,
  borderRadius: '35px',
  '& .MuiInputBase-input': {
    color: 'white',
    paddingLeft: '5px',
  },
  '& .MuiInputLabel-root': {
    color: '#7D7D7D', // Label color
    left: '50.5px',
    marginLeft: '12px',
    marginTop: '2px',
    transform: 'translate(0, +16px)', // Position the label beside the icon
  },
  '& .MuiInputLabel-shrink': {
    left: '50.5px', // Move label to top on focus
    color: '#7D7D7D',
    marginLeft: '12px',
    fontSize: '12px',
    transform: 'translate(0, -1px)',
    paddingTop: '8px', // Adjust position when focused
  },
  '& .MuiInputLabel-outlined.Mui-focused': {
    color: 'white', // Color of label when focused
  },
  '& .MuiFilledInput-root': {
    '&:before': {
      borderBottom: 'none', // Remove default underline
    },
    '&:after': {
      borderBottom: 'none', // Remove focus underline
    },
    '&.Mui-focused:after': {
      color: '#7D7D7D',
      borderBottom: 'none', // Disable blue focus underline
    },
  },
  '&::placeholder': {
    color: '#7D7D7D', // Placeholder text color
    opacity: 1, // Ensure the color is fully applied
  },
}));

const CardHolderNameInput: React.FC<CardHolderNameInputProps> = ({
  type,
  value,
  onChange,
  label,
  placeholder,
  ...props
}) => {
  const [focused, setFocused] = useState(false);

  const handleFocus = (event: FocusEvent<HTMLInputElement>) => setFocused(true);
  const handleBlur = (event: FocusEvent<HTMLInputElement>) => setFocused(false);

  return (
    <CustomInputField
      value={value}
      type={type}
      label={label}
      variant="filled"
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src={UserIcon} className="card-name-input" />
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: focused || Boolean(value), // Control shrink based on value
      }}
      {...props}
    />
  );
};

export default CardHolderNameInput;
